import React from 'react';
import propTypes from 'prop-types';
import HedinIcon from '@hedinbil/hedin-ui/dist/icons/components/HedinIcon';
import { getPageType, showRangeResult } from './utils';

const FacetList = ({ facets, pageIndex, loading, onChangeActivePage }) => (
  <div className={`hb-filter__content ${loading ? 'hb-filter__content-loading' : ''}`}>
    {(facets || []).map((facet, index) => {
      const rangeIsZero = facet?.chosenMinValue === 0 && facet?.chosenMaxValue === 0;
      const valuesAreVisible =
        getPageType(facet?.key) === 'range' && showRangeResult(facet) && !rangeIsZero;
      const filterDisabledStyle = rangeIsZero ? { opacity: '0.4' } : null;

      return (
        <div
          className={'hb-filter__item' + (pageIndex === index ? ' active' : '')}
          onClick={() => onChangeActivePage(index)}
          key={index}
        >
          <span style={filterDisabledStyle}>{facet?.title} </span>
          {facet?.activeFilters && facet?.activeFilters > 0 ? (
            <div className="button--filter-count text-center color-white">
              <span>{facet?.activeFilters}</span>
            </div>
          ) : null}
          {valuesAreVisible ? (
            <div className="hb-filter__item-range-result d-inline-block fw-300">
              {facet?.chosenMinValue} - {facet?.chosenMaxValue}
            </div>
          ) : null}
          <HedinIcon
            iconName="ChevronRight"
            className="hb-filter__item-icon"
            style={filterDisabledStyle}
          />
        </div>
      );
    })}
  </div>
);
FacetList.propTypes = {
  facets: propTypes.array,
  pageIndex: propTypes.number,
  loading: propTypes.bool,
  onChangeActivePage: propTypes.func,
};

export default FacetList;
